var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cont"},[_c('img',{attrs:{"src":require("../assets/imgs/1.jpg"),"alt":""}}),_c('img',{attrs:{"src":require("../assets/imgs/2.jpg"),"alt":""}}),_c('img',{attrs:{"src":require("../assets/imgs/3.jpg"),"alt":""}}),_c('img',{attrs:{"src":require("../assets/imgs/4.jpg"),"alt":""}}),_c('img',{attrs:{"src":require("../assets/imgs/5.jpg"),"alt":""}})])
}]

export { render, staticRenderFns }